// removed by extract-text-webpack-plugin
module.exports = {"continue-without-signin":"UnauthenticatedPaymentsLink__continue-without-signin","continueWithoutSignin":"UnauthenticatedPaymentsLink__continue-without-signin"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/UnauthenticatedPaymentsLink/UnauthenticatedPaymentsLink.scss
// module id = 1513
// module chunks = 8